<template>
    <div class="dt-pagination">
        <span class="dt-pagination-info">
            {{ rangeStart }}–{{ rangeEnd }}
            <template v-if="totalCount"> / {{ totalFormatted }}</template>
            {{ $t('common.dataTable.totalCount') }}
        </span>
        <div class="dt-pagination-pages">
            <button class="dt-page-btn dt-page-btn--nav" :disabled="currentPage <= 1" @click="goTo(currentPage - 1)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <template v-for="p in pageButtons" :key="p">
                <span v-if="p === '...'" class="dt-page-ellipsis">…</span>
                <button v-else class="dt-page-btn" :class="{'dt-page-btn--active': p === currentPage}" @click="goTo(p)">{{ p }}</button>
            </template>
            <button class="dt-page-btn dt-page-btn--nav" :disabled="currentPage >= totalPages" @click="goTo(currentPage + 1)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DataTablePagination',
    props: {
        currentPage: { type: Number, default: 1 },
        pageLimit: { type: Number, default: 25 },
        totalCount: Number,
        loadingMore: Boolean,
    },
    emits: ['page-change'],
    computed: {
        totalFormatted() {
            return (this.totalCount || 0).toLocaleString('tr-TR')
        },
        totalPages() {
            if (!this.totalCount || !this.pageLimit) return 1
            return Math.ceil(this.totalCount / this.pageLimit)
        },
        rangeStart() {
            return ((this.currentPage - 1) * this.pageLimit) + 1
        },
        rangeEnd() {
            const end = this.currentPage * this.pageLimit
            return this.totalCount ? Math.min(end, this.totalCount) : end
        },
        pageButtons() {
            const total = this.totalPages
            const current = this.currentPage
            if (total <= 7) {
                return Array.from({ length: total }, (_, i) => i + 1)
            }
            const pages = []
            pages.push(1)
            if (current > 3) pages.push('...')
            const start = Math.max(2, current - 1)
            const end = Math.min(total - 1, current + 1)
            for (let i = start; i <= end; i++) pages.push(i)
            if (current < total - 2) pages.push('...')
            pages.push(total)
            return pages
        },
    },
    methods: {
        goTo(page) {
            if (page < 1 || page > this.totalPages || page === this.currentPage) return
            this.$emit('page-change', page)
        },
    },
}
</script>
